import {gql} from '@apollo/client';

export const MUTATION_MENTORING_RATE = gql`
  mutation MentoringRate($input: MentoringRateInput!) {
    mentoringRate(input: $input) {
      obj {
        id
        rating
      }
      errors {
        field
        messages
      }
    }
  }
`;
